// src/com/home/TransPlanTodayForStatus.js
import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button, DialogContent, DialogActions, Dialog, DialogTitle } from '@mui/material';
import WavingHandIcon from '@mui/icons-material/WavingHand'; // left
import LocalShippingIcon from '@mui/icons-material/LocalShipping'; // assigned.
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard'; // waiting
import { AppObject, AppStyle } from '../../value/AppConst';
import { ContentConainer, ContentHeader, ControlBox, CountLabel, ToolBox } from '../../common/TopViewControl';
import FlexyTable from '../../common/flexytable/FlexyTable';
import { TransPlanAndActorDictionary } from '../trans_plan_and_actor/TransPlanAndActorDict';
import SearchBox from '../../common/SearchBox';
import { useLazyQuery } from '@apollo/client';
import { LIST_TRANS_PLAN_AND_ACTOR_TODAY_FOR_STATUS } from '../trans_plan_and_actor/TransPlanAndActorGql';
import { useAlertSetter } from '../../api/app-hook';


const ViewerTitle = styled(DialogTitle)({
    backgroundColor: AppStyle.SuccessRGB, color: 'white', display: 'flex', alignItems: 'center'
});
const IconBox = styled('div')({
    marginRight: 10,
});

export const TransPlanRequestState = {
    left: 'left',
    assigned: 'assigned',
    waiting: 'waiting',
};

const TableProps = TransPlanAndActorDictionary.tablePropsForTodayForReqStatus;

/**
 * 출차완료, 출차대기, 배차대기 상태인 배차목록 조회.
 * TopHome에서 테이블의 숫자를 누르면 이 컴포넌트를 띄움.
 */
export default function TransPlanTodayForStatus({
    open,
    dcCd,
    reqState, // 'left', 'assigned', 'waiting'
    onClose,
    dcTypeName,
    dcName
}) {
    const [records, setRecords] = useState([]); // Let's not use AppModel for this prompt request.
    const [countToDisplay, setCountToDisplay] = useState(0);
    const [searchText, setSearchText] = useState('');
    const addAlert = useAlertSetter();
    const requestedRef = useRef(false);

    const [getTransPlanAndActorList, responseList] = useLazyQuery(LIST_TRANS_PLAN_AND_ACTOR_TODAY_FOR_STATUS, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
        onError: (error) => addAlert({title: '데이터 조회 오류', message: [error.message]})
    });

    const getTransPlanAndActorListNow = () => {
        getTransPlanAndActorList({variables: {dcCd, reqState}});
    };

    useEffect(() => {
        if(open) {
            if(!requestedRef.current) {
                requestedRef.current = true;
                getTransPlanAndActorListNow();
            }
        }
        else requestedRef.current = false;
    }, [open]);
    
    const onCompleteGetList = (data, clientOption) => {
        if(data.transPlanListTodayForStatus) {
            setRecords(data.transPlanListTodayForStatus);
            setCountToDisplay(data.transPlanListTodayForStatus.length);
        }
    };

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    return(
        <Dialog open={open} onClose={onClose}
            fullScreen
        >
            <ViewerTitle>
                <IconBox>
                    {
                        reqState===TransPlanRequestState.left ?
                        <WavingHandIcon fontSize="large" /> :
                        reqState===TransPlanRequestState.assigned ?
                        <LocalShippingIcon fontSize="large" /> :
                        <DepartureBoardIcon fontSize="large" />
                    }
                </IconBox>
                <div>
                    {
                        reqState===TransPlanRequestState.left ?
                        '출차완료' :
                        reqState===TransPlanRequestState.assigned ?
                        '출차대기' :
                        '배차대기'
                    }: {dcTypeName} - {dcName}
                </div>
            </ViewerTitle>
            <DialogContent>
                <ContentConainer>
                    <ContentHeader>
                        <ControlBox>
                            <SearchBox
                                value={searchText}
                                onChangeText={onChangeSearchText}
                                width={180}
                            />
                        </ControlBox>
                        <ToolBox>
                            <CountLabel count={countToDisplay} />
                        </ToolBox>
                    </ContentHeader>
                    <FlexyTable
                        name={TableProps.tableId}
                        tableProps={TableProps}
                        records={records}
                        onChangeCountToDisplay={setCountToDisplay}
                        search={searchText}
                    />
                </ContentConainer>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color={AppStyle.mui.primary}
                    variant={AppStyle.mui.contained}
                    fullWidth
                >
                    닫기
                </Button>
            </DialogActions>
        </Dialog>
    );
}